import { useIsRTL } from '../../locale';
import { elementIsFullyVisible, elementLeftIsClipped, elementRightIsClipped, moveFocus, scrollHorizontal } from './horizontalScroll';
import { elementBottomIsClipped, elementTopIsClipped, scrollVertical } from './verticalScroll';

/**
 * Returns API which can be used for horizontal or vertical scrolling
 * @param containerRef - reference for the containing DOM element which needs to be scrolled
 * @param orientation - orientation of the component.
 * @param contentsRef - optional. Array of references
 *
 */
export function useScroll(containerRef,
// Element for which scrollLeft needs to be updated
orientation, contentsRef) {
  const isRTL = useIsRTL();
  if (!orientation || orientation === 'horizontal') {
    return {
      scrollToPrevious: () => moveFocus('back', containerRef, contentsRef, isRTL),
      scrollToNext: () => moveFocus('next', containerRef, contentsRef, isRTL),
      scrollTo: (item, scrollTo) => {
        const container = containerRef.current;
        if (!container) return;
        scrollHorizontal(container, item.getBoundingClientRect(), scrollTo);
      },
      elementIsFullyVisible: element => {
        const container = containerRef.current;
        if (!container) return false;
        return elementIsFullyVisible(container, element);
      },
      elementBackIsClipped: element => {
        const container = containerRef.current;
        if (!container) return false;
        return isRTL ? elementRightIsClipped(container, element) : elementLeftIsClipped(container, element);
      },
      elementNextIsClipped: element => {
        const container = containerRef.current;
        if (!container) return false;
        return isRTL ? elementLeftIsClipped(container, element) : elementRightIsClipped(container, element);
      }
    };
  }
  return {
    scrollTo: (item, scrollTo) => {
      const container = containerRef.current;
      if (!container) return;
      scrollVertical(container, item.getBoundingClientRect(), scrollTo);
    },
    elementIsFullyVisible: element => {
      const container = containerRef.current;
      if (!container) return false;
      return !elementTopIsClipped(container, element) && !elementBottomIsClipped(container, element);
    },
    elementBackIsClipped: element => {
      const container = containerRef.current;
      if (!container) return false;
      return elementTopIsClipped(container, element);
    },
    elementNextIsClipped: element => {
      const container = containerRef.current;
      if (!container) return false;
      return elementBottomIsClipped(container, element);
    }
  };
}
//# sourceMappingURL=useScroll.js.map